import useEventEndHandler from '@hooks/useEventEndHandler';
import { Spacings } from '@styles/index';
import { useCallback, useEffect, useState } from 'react';

const useGetPlannerHeight = () => {
  const [containerHeight, setContainerHeight] = useState(
    typeof window !== 'undefined'
      ? window.innerHeight - Spacings.SPACING_HEADER
      : 0
  );

  const resizeHandler = useCallback(() => {
    if (typeof window !== 'undefined') {
      setContainerHeight(window.innerHeight - Spacings.SPACING_HEADER);
    }
  }, []);
  const onResize = useEventEndHandler(resizeHandler, 300);

  useEffect(() => {
    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, [onResize]);

  return containerHeight;
};

export default useGetPlannerHeight;
